__turbopack_context__.v({
  "banner": "banner-module__h8f1xG__banner",
  "description": "banner-module__h8f1xG__description",
  "iconWrap": "banner-module__h8f1xG__iconWrap",
  "left": "banner-module__h8f1xG__left",
  "text": "banner-module__h8f1xG__text",
  "title": "banner-module__h8f1xG__title",
  "toneAccent": "banner-module__h8f1xG__toneAccent",
});
